"use client";

import * as React from "react";

import { usePopupStore } from "@/stores/popup";

export function PopupConsoleLog() {
  const { data, error, isLoading, popup } = usePopupStore();

  React.useEffect(() => {
  }, [data, error, isLoading, popup]);

  return null;
}

